<template>
  <div class="home-view internal">
    <section class="form">
      <div class="container">
        <!-- <h1 class="title-default">Cadastro <span>Para solicitar uma alteração de cadastro informe abaixo seus novos dados.<br> Nossa equipe fará contato confirmando a alteração ou para tirar eventuais dúvidas.</span></h1> -->
        <h1 class="title-default">Seus dados</h1>

        <form v-if="info">
          <h3>{{ $store.state.nome }}</h3>
          <h4>{{ $store.state.documento }}</h4>

          <h6>Dados pessoais</h6>

          <fieldset>
            <input type="text" required placeholder="Nome" :value="info.AGN_ST_FANTASIA" readonly>
          </fieldset>

          <fieldset v-if="$store.state.documento">
            <input type="text" required placeholder="CPF" :value="$store.state.documento" readonly>
          </fieldset>

          <fieldset>
            <input type="email" required placeholder="E-mail" :value="info.AGN_ST_EMAIL" readonly>
          </fieldset>

          <fieldset>
            <input type="text" required placeholder="Telefone resid." :value="info.AGN_ST_TELEFONE" readonly>
          </fieldset>

          <h6 v-if="$store.state.conjugeNome || $store.state.conjugeCPF">Dados cônjunge</h6>

          <fieldset v-if="$store.state.conjugeNome">
            <input type="text" required placeholder="Nome" :value="$store.state.conjugeNome" readonly>
          </fieldset>

          <fieldset v-if="$store.state.conjugeCPF">
            <input type="text" required placeholder="CPF" :value="$store.state.conjugeCPF" readonly>
          </fieldset>

          <h6>Endereço</h6>

          <!-- <div class="fieldset cep"> -->
          <div class="fieldset">
            <input type="text" required placeholder="CEP" :value="info.AGN_ST_CEP" readonly>
            <!-- <a href="javascript:void(0)" class="btn">Verificar</a> -->
          </div>

          <fieldset>
            <input type="text" required placeholder="Endereço" :value="info.AGN_ST_LOGRADOURO" readonly>
          </fieldset>

          <fieldset>
            <input type="text" required placeholder="Número" :value="info.AGN_ST_NUMERO" readonly>
          </fieldset>

          <fieldset>
            <input type="text" required placeholder="Complemento" :value="info.AGN_ST_COMPLEMENTO" readonly>
          </fieldset>

          <div class="fieldset col-2">
            <input type="text" required placeholder="Cidade" :value="info.AGN_ST_MUNICIPIO" readonly>

            <input type="text" required placeholder="Bairro" :value="info.AGN_ST_BAIRRO" readonly>
          </div>

          <!-- <div class="fieldset col-2">
            <input type="text" required placeholder="Estado" :value="info.AGN_ST_MUNICIPIO" readonly>
          </div> -->

          <!-- <fieldset class="submit">
            <button type="submit">Salvar</button>
          </fieldset> --> <!-- /.submit -->
        </form> <!-- /form -->

        <form v-else>
          <h6>Carregando...</h6>
        </form>
      </div> <!-- /.container -->
    </section> <!-- /.form -->
  </div>
</template>

<script>
import PagesService from '@/services/Pages'

export default {
  name: 'cadastro',

  data () {
    const data = {
      info: null
    }

    return data
  }, // data()

  mounted () {
    this.load()
  }, // mounted()

  methods: {
    async load () {
      try {
        let { contratoAtual } = this.$store.state
        this.info = await PagesService.getExtrato(contratoAtual.codigo)
      } catch (e) {
        console.error('Falha ao recuperar cadastro', e)
      }
    } // load()
  }, // methods

  computed: {
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  section.form form
    input, textarea
      background-color: map-get($colors, bg_body) !important

    h3, h6
      color: #919191 !important

    h4
      font-weight: 700

    .cep
      input
        width: 100%

      .btn
        width: 190px
        height: 45px
        padding: 0
        margin-left: 20px
        font-weight: 700
        font-size: 22px

    .submit
      display: flex
      justify-content: center

      button
        width: 255px
        height: 45px
        padding: 0
        margin-left: 20px
        font-weight: 700
        font-size: 22px

    fieldset,
    .fieldset
      input[type="text"],
      input[type="email"],
      input[type="password"],
      textarea
        font-style: normal

  @media (max-width: 767px)
    section.form
      form
        h3, h6
          font-size: 20px

        h4
          color: #000 !important
          font-weight: 700

        input
          font-size: 13px !important

        .submit
          button
            width: 100%
            margin-left: 0 !important
            font-size: 18px !important
</style>
